module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/door.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2title"
  }, [_c('strong', [_vm._v("The Opportunity")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("How can leadership be this hard? One year ago today was the happiest day of my life. I had arrived! Only four years out of college, and my company had moved me into a leadership position: director of corporate client services for the southeast sales region. I knew I could handle the job, because I’d started from our catalog call center, fielding customer requests and complaints. Then I was promoted to a project manager, working closely with sales and our corporate clients. Whatever the salespeople promised our customers, I delivered. And if I do say so myself, I was good at getting our corporate clients what they needed, when and where they needed it. I got all kinds of kudos for developing outstanding relationships with clients. I was sure I could make my staff do the same.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A year ago, I was on top of the world. Today, I’m holding on for dear life and might lose my job. What happened? What went wrong?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With those thoughts, Debbie Brewster pulled into the parking lot at the public library. She knew she could never have an uninterrupted day in the office. Besides, her boss had always encouraged her to take some time every month to step back and Assess what had happened, Affirm what was working, "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("and make Adjustments as needed. She had always been too busy to actually try it, but today was different. Drastic times demand drastic measures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Debbie entered the library, her mind flashed back to long-forgotten memories from her less-than-stellar educational career. The musty smell of the old volumes was as strong as ever. The lighting was about the same—a bit too dark. That had never made much sense to her. "), _c('em', [_vm._v("Why aren’t libraries better lit?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Debbie approached the librarian and said, “Hi, I’m looking for a place to work. Somewhere with ample light, if that’s possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Certainly,” the woman said with a smile. “Are there any particular resources you’ll need today?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, but thanks anyway. I just need a quiet place to work for a few hours. I have a few business issues that I need to resolve.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me know if you need any help,” the librarian offered. She escorted Debbie to a table in a quiet corner with two large windows on each side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Debbie took a seat, pulled out her laptop and began. "), _c('em', [_vm._v("First, I need to get a firm grip on my current situation. Then I’ll try to determine how I got into this mess.")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Current Situation")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "80%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _c('tbody', [_c('tr', [_c('th')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Feedback from")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Worst among all")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("salespeople")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("7 sales regions")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Customer")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Worst among all")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("satisfaction")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("7 sales regions")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Profit contribution")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Below goal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Cost management")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("At goal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Employee")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Significantly below")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("satisfaction")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("where it was when I took over the team.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Turnover")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("I’ve lost 4 out of 10 team members in less than a year. This feels like an issue.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('em', [_vm._v("Okay, that’s where we are today. How did things get so bad, so fast?")]), _vm._v(" She thought back over the previous twelve months. Which events might have contributed to her team’s current lackluster performance?")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Key Events")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "80%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _c('tbody', [_c('tr', [_c('th')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("June 1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("I am appointed as team leader.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("June 15")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("First team meeting; conflict over changes I wanted the team to implement.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("July")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Selected Bob—new to the company—poor decision.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("August")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Cut expenses to improve profitability.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("September")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Two new hires: Brenda—good fit; Charles—wait and see.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("October")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Lost one important client due to poor service from our people.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("November")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Bob terminated. Team seems very disengaged.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("December")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Year-end results reflect significant drop in team performance versus previous year.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("January")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Performance reviews with each member of the team. Every team member is challenged to “step up or step out.”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("February")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Lost two more clients—same reason as before.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("May")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Team meetings canceled until further notice. Focus on improving results.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('em', [_vm._v("Wow! No wonder it was a bad year. Look at all the stuff that happened. Unfortunately, I don’t think “stuff just happened” is the insight I need to turn things around.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Debbie’s somber thought was interrupted by the librarian. “How’s your work going? Getting everything done?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not exactly. I’ve reviewed the current situation, but I don’t know where to go from here,” Debbie admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe I can help,” the librarian said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Debbie was amused by the comment but tried not to show it. “Well, thank you, but I’m not sure you could. It’s a complex problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I didn’t mean that I could personally help you solve your problem,” the woman responded "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("patiently. “However, we do have quite a few resources about business at our disposal. What is the problem you’re trying to solve?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In our company, we often refer to problems as opportunities,” Debbie explained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, what’s the opportunity?” the woman said with a smile as she continued to probe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think I could sum it up by saying that I have an opportunity to improve the performance of my team.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you know what’s causing the performance issues?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Debbie paused. “I’m not sure. I listed all the key events from the last year and several things that could have contributed, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But what?” the woman asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I get this sinking feeling that I may be a significant part of the problem. I’ve only been the team leader for about a year, and I have no prior training or experience.” Debbie thought, "), _c('em', [_vm._v("I can’t believe I’m baring my soul to the librarian")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ve got quite a few resources on leadership development,” the librarian offered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Leadership development,” Debbie repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” said the librarian, “you said you might be part of the problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think I said I might be a contributing factor, but the real issue is performance.” Debbie could feel herself getting defensive. It was one thing to admit she might be part of the problem. It had a different ring to it when she heard someone else say it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("The librarian stepped back. “Okay, I’ll leave you alone to work on it yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the woman walked away, Debbie reconsidered. "), _c('em', [_vm._v("Maybe there are some new leadership tricks I can learn.")]), _vm._v(" What could she lose at this point? Only her job and her dream. “Wait!” she called out. “I’m sorry. I was a bit defensive. I’ve been under a lot of pressure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman turned back with an understanding smile. “It’s okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where are those resources that you mentioned?” Debbie asked, relieved that the librarian was still willing to help.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("“Follow me.” The librarian led Debbie to a nearby computer, and together they scrolled through the listings, which included titles such as these:")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_vm._v("• "), _c('em', [_vm._v("The Power of 360-Degree Feedback")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_vm._v("• "), _c('em', [_vm._v("Development Plans That Work")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_vm._v("• "), _c('em', [_vm._v("Leaders Mentoring Leaders")])]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_vm._v("• "), _c('em', [_vm._v("What Do Leaders Do?")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Debbie began to see something as they scrolled from screen to screen. The word "), _c('em', [_vm._v("mentoring")]), _vm._v(" was repeated several times; in fact, it was repeated on almost every screen she viewed. Then it hit her!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Excuse me,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("She went back to her laptop and opened her e-mail. She was sure she had seen a message that had something to do with mentoring. It read:")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _c('tbody', [_c('tr', [_c('th')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Send to:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtextr"
  }, [_vm._v("All Supervisors and Managers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("From:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtextr"
  }, [_vm._v("Melissa Arnold")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Subject:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtextr"
  }, [_vm._v("Mentoring Opportunities")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtext"
  }, [_vm._v("Date:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabtextr"
  }, [_vm._v("May 23")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("As outlined in our annual plan, we indicated that assisting the current and next generation of leaders would be one of our top priorities for this year and for years to come. We believe that one way we can assist our emerging leaders is to establish a formal mentoring program within the organization. We want to be very clear that this program is optional. Any of you who wish to participate need to submit an application to me before June 1.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("If you would like additional information about the program, there will be a “Lunch and Learn” on Friday, May 28, in the fourth floor conference room from 12:15 until 1 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M")]), _vm._v(". Bring your own lunch.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('em', [_vm._v("This could be the ticket")]), _vm._v(", Debbie thought. "), _c('em', [_vm._v("I’m sure a mentor from within the company would help solve the issues in my area. My mentor will probably be able to diagnose the problem and tell me how to fix it in a meeting or two. Besides, it might even look good in my personnel file to say that I was mentored by an executive.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An alarm went off in Debbie’s mind: "), _c('em', [_vm._v("Today is the 28th! I’ve missed the informational meeting. But if I leave now, I can go by the office and pick up one of those applications, fill it out this weekend, and submit it Monday morning before the deadline.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("Debbie gathered her things and headed for the library exit. “Thanks for your help,” she called to the librarian on her way out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Any time,” the woman replied with a smile. “Good luck!”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c53c630","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 75
// module chunks = 0